import axios from '@/libs/api.request'

export const getsysparameterList = (key, value, sysuser, page, limit, tables) => {
    return axios.request({
      url: '/v1/cmdb/sys_parameter/',
      method: 'get',
      params: {
        key,
        value,
        sysuser,
        page,
        limit,
        tables
      }
    })
  }

export const operationsysparameter = (data, meth) => {
  return axios.request({
    url: '/v1/cmdb/sys_parameter/',
    method: meth,
    data
  })
}
